export class Activity {
    setCompleted() {
        if (this.isCompleted.value) {
            return;
        }
        this.isCompleted.set(true);
    }
}
